import React from 'react';
import { Flex, Text } from '@opendoor/bricks/core';
import ImgixImg from '@opendoor/bricks/utils/ImgixImg';

type ExteriorAssessmentLabelProps = {
  displayText?: string;
};

/** TODO: Add documentation */
export const ExteriorAssessmentLabel: React.FC<ExteriorAssessmentLabelProps> = ({
  displayText,
}) => (
  <Flex>
    <ImgixImg width={18} height={18} src="d761993fcdea46d8aa734d928abf4dfe.svg" alt="" />
    <Text fontSize="s0" lineHeight="s00" fontWeight="bold" color="green50">
      {displayText ? displayText : 'Exterior assessment scheduled'}
    </Text>
  </Flex>
);
